import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新快讯</h2>
          <p className="mt-2 text-sm text-foreground-500">实时追踪 · 分秒必达</p>
        </div>

        <div className="relative pl-6 border-l-2 border-primary-200 space-y-6">
          {updatesData.map((item, idx) => (
            <div key={idx} className="relative pl-6">
              <div className="absolute left-[-29px] top-1.5 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap ${
                  item.tag === '独家' ? 'bg-primary-100 text-primary-700' :
                  item.tag === '热议' ? 'bg-accent-100 text-accent-800' :
                  item.tag === '最新' ? 'bg-secondary-100 text-secondary-800' :
                  'bg-background-200 text-foreground-600'
                }`}>{item.tag}</span>
                <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-relaxed flex-1">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}